<template>
  <el-card>
    <div slot="header" class="font-weight-bold d-flex justify-content-between">
      <div>{{ $t('general.your_profile') }}</div>
      <el-link type="primary" @click="onEdit">
        {{ $t('general.edit') }}
      </el-link>
    </div>
    <div>
      <table class="el-table">
        <tr>
          <th class="w-25">
            {{ $t('general.firstname') }}
          </th>
          <td>{{ currentUser.get('firstname') }}</td>
        </tr>
        <tr>
          <th class="w-25">
            {{ $t('general.lastname') }}
          </th>
          <td>{{ currentUser.get('lastname') }}</td>
        </tr>
        <tr>
          <th class="w-25">
            {{ $t('general.email') }}
          </th>
          <td>{{ currentUser.get('email') }}</td>
        </tr>
        <tr>
          <th class="w-25">
            {{ $t('general.company') }}
          </th>
          <td>{{ currentUser.get('company') }}</td>
        </tr>
        <tr>
          <th class="w-25">
            {{ $t('general.address') }}
          </th>
          <td>{{ address }}</td>
        </tr>
        <tr>
          <th class="w-25">
            {{ $t('general.language') }}
          </th>
          <td>{{ currentUser.get('language') }}</td>
        </tr>
      </table>
    </div>
  </el-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import StoreModules from '../../../store/store-modules';
import EditUserDetailsModal from '../../../components/modals/EditUserDetailsModal';
export default {
  name: 'ManageProfileCard',
  components: {},
  props: {},
  mounted() {},
  destroyed() {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters(StoreModules.USER, ['currentUser', 'fullName']),
    address() {
      return `${this.currentUser.get('country')}-${this.currentUser.get('zipCode')} ${this.currentUser.get(
        'city'
      )}, ${this.currentUser.get('street')}`;
    },
  },
  methods: {
    onEdit() {
      this.$modal.show(EditUserDetailsModal, {}, { height: 'auto', width: '98%', maxWidth: 600, adaptive: true });
    },
  },
};
</script>

<style scoped></style>
